<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content--scrollable" v-if="billPayment">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Reembolsar Pagamento
          </h4>
        </div>

        <div class="modal-body modal-body--scrollable">
          <div class="modal-body__field">
            <div v-if="!billPayment.is_refundable">
              <z-alert
                variant="warning"
                title="Pagamento fora do prazo de reembolso automático!"
                description="Contate o financeiro para que eles realizem o estorno manual.
                Após o reembolso ter sido concluído, marque o pagamento como reembolsado clicando no botão abaixo."
              />
            </div>
            <h3>Dados do pagamento</h3>
            <input-field
              label="ID da mensalidade"
              v-model="billPayment.bill_id"
              :disabled="true"
            />
            <input-field
              label="ID do pagamento"
              v-model="billPayment.id"
              :disabled="true"
            />
            <input-field
              label="Tipo do pagamento"
              v-model="billPayment.translated_method_type"
              :disabled="true"
            />
            <money-field
              label="Valor pago"
              v-model="paidValue"
              :disabled="true"
            />
            <input-field
              label="Vencimento"
              v-model="dueDate"
              :formatter="formatDate"
              :disabled="true"
            />
            <input-field
              label="Pago em"
              v-model="paidDate"
              :disabled="true"
            />
            <div v-if="billPayment.method_type === 'boleto' && billPayment.is_refundable">
              <h3>Conta bancária</h3>
              <select-field
                label="Banco"
                v-model="bankAccount.get('bankCode').value"
                :errors="bankAccount.get('bankCode').errors"
                :options="recipientEnums.bank_codes"
                v-if="enumsLoaded"
              />
              <input-field
                label="Agência"
                mask="####"
                v-model="bankAccount.get('agencia').value"
                :errors="bankAccount.get('agencia').errors"
                @input="bankAccount.get('agencia').validateField()"
              />
              <input-field
                label="Dígito da agência"
                mask="X"
                v-model="bankAccount.get('agenciaDv').value"
                :errors="bankAccount.get('agenciaDv').errors"
                @input="bankAccount.get('agenciaDv').validateField()"
              />
              <select-field
                label="Tipo da conta"
                v-model="bankAccount.get('type').value"
                :errors="bankAccount.get('type').errors"
                :options="recipientEnums.bank_account_types"
                v-if="enumsLoaded"
              />
              <input-field
                label="Conta"
                mask="#############"
                v-model="bankAccount.get('conta').value"
                :errors="bankAccount.get('conta').errors"
                @input="bankAccount.get('conta').validateField()"
              />
              <input-field
                label="Dígito da conta"
                mask="X"
                v-model="bankAccount.get('contaDv').value"
                :errors="bankAccount.get('contaDv').errors"
                @input="bankAccount.get('contaDv').validateField()"
              />
              <input-field
                label="Nome do titular da conta"
                v-model="bankAccount.get('legalName').value"
                :errors="bankAccount.get('legalName').errors"
                @input="bankAccount.get('legalName').validateField()"
              />
              <input-field
                label="CPF/CNPJ"
                :mask="['##.###.###/####-##', '###.###.###-##']"
                v-model="bankAccount.get('documentNumber').value"
                :errors="bankAccount.get('documentNumber').errors"
                @input="bankAccount.get('documentNumber').validateField()"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="billPayment.is_refundable" class="btn btn-primary" @click="refund()">
            Reembolsar
          </button>
          <button v-else class="btn btn-danger" @click="refundManually()">
            Reembolsado Manualmente
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { FormGroup } from 'utils/form';
import { InputField, MoneyField, SelectField } from 'components/form';
import moment from 'moment';
import BillPaymentService from 'services/BillPaymentService';

export default {

  props: {
    billPayment: {
      type: Object,
      default: null,
    },
  },
  components: {
    InputField,
    MoneyField,
    SelectField,
  },
  created() {
    this.$loader.show();

    this.loadRecipientEnums()
      .then(() => {
        this.enumsLoaded = true;
      })
      .catch(() => {
        this.enumsLoaded = false;
        this.$alert.notifyAlert('Erro ao buscar informações, tente novamente mais tarde');
      });

    this.$loader.hide();
  },
  computed: {
    ...mapState([
      'recipientEnums',
    ]),
    paidValue() {
      return parseFloat(this.billPayment.paid_value);
    },
    dueDate() {
      return this.formatDate(this.billPayment.expiry_date);
    },
    paidDate() {
      return this.formatDate(this.billPayment.paid_at);
    },
  },
  data() {
    return {
      enumsLoaded: false,
      bankAccount: new FormGroup({
        bankCode: { required: true },
        agencia: { required: true },
        agenciaDv: { required: false },
        conta: { required: true },
        contaDv: { required: true },
        type: { required: true },
        legalName: { required: true },
        documentNumber: { required: true },
      }),
    };
  },
  methods: {
    ...mapActions([
      'loadRecipientEnums',
    ]),
    formatDate(value) {
      if (value) return moment(value).format('DD/MM/YYYY');
      return undefined;
    },
    refund() {
      if (this.billPayment.method_type === 'boleto' && !this.bankAccount.validateForm()) return;
      this.$loader.show();

      BillPaymentService.refundPayment(this.billPayment.id, this.bankAccount.getRawValue()).then(() => {
        this.$emit('close');
        this.$alert.notifySuccess('Reembolso feito com sucesso');
      }).catch(() => {
        this.$alert.notifyAlert('Erro ao fazer o reembolso');
      }).finally(() => {
        this.$loader.hide();
      });
    },
    refundManually() {
      this.$loader.show();

      BillPaymentService.refundPaymentManually(this.billPayment.id).then(() => {
        this.$emit('close');
        this.$alert.notifySuccess('Status do pagamento atualizado para reembolsado com sucesso!');
      }).catch(() => {
        this.$alert.notifyAlert('Erro ao atualizar status do pagamento para reembolsado');
      }).finally(() => {
        this.$loader.hide();
      });
    },
  },
};
</script>

<style type="text/css">
  .input-group-btn>select {
    font-size: 20px;
  }
</style>
